import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="flex justify-between items-center py-4" data-id="element-152">
          <div className="flex items-center" data-id="element-153">
            <span className="text-2xl font-bold text-amber-600" data-id="element-154">
              CateringCareers
            </span>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-10" data-id="element-155">
            <a href="#" className="text-gray-700 hover:text-amber-600 font-medium" data-id="element-156">
              Find Jobs
            </a>
            <a href="#" className="text-gray-700 hover:text-amber-600 font-medium" data-id="element-157">
              For Employers
            </a>
            <a href="#" className="text-gray-700 hover:text-amber-600 font-medium" data-id="element-158">
              How It Works
            </a>
            <a href="#" className="text-gray-700 hover:text-amber-600 font-medium" data-id="element-159">
              About
            </a>
          </nav>
          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-160">
            <a href="#" className="text-gray-700 hover:text-amber-600 font-medium" data-id="element-161">
              Log In
            </a>
            <a href="#" className="bg-amber-600 text-white px-4 py-2 rounded-md hover:bg-amber-700 transition font-medium" data-id="element-162">
              Sign Up
            </a>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-163">
            <button type="button" className="text-gray-700 hover:text-amber-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-164">
              {isMenuOpen ? <X size={24} data-id="element-165" /> : <Menu size={24} data-id="element-166" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden" data-id="element-167">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-168">
            <a href="#" className="block px-3 py-2 text-gray-700 hover:text-amber-600 font-medium" data-id="element-169">
              Find Jobs
            </a>
            <a href="#" className="block px-3 py-2 text-gray-700 hover:text-amber-600 font-medium" data-id="element-170">
              For Employers
            </a>
            <a href="#" className="block px-3 py-2 text-gray-700 hover:text-amber-600 font-medium" data-id="element-171">
              How It Works
            </a>
            <a href="#" className="block px-3 py-2 text-gray-700 hover:text-amber-600 font-medium" data-id="element-172">
              About
            </a>
            <div className="flex flex-col space-y-2 mt-4" data-id="element-173">
              <a href="#" className="px-3 py-2 text-gray-700 hover:text-amber-600 font-medium" data-id="element-174">
                Log In
              </a>
              <a href="#" className="bg-amber-600 text-white px-3 py-2 rounded-md hover:bg-amber-700 transition text-center font-medium" data-id="element-175">
                Sign Up
              </a>
            </div>
          </div>
        </div>}
    </header>;
}